<template>
  <div class="col s12 m6 l4">
    <div class="card light-blue bill-card">
      <div class="card-content white-text">
        <span class="card-title">{{'billInCur' | langFilter}}</span>

        <p v-for="cur in currencies" :key="cur" class="currency-line">
          <span>{{ getCur(cur) | currencyFilter(cur)}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['rates'],
    data: () => ({
      currencies: ["RUB", "USD", "EUR"]
    }),
    computed: {
      bill() {
        return this.$store.getters.info.bill / this.rates.RUB;
      },
    },
    methods: {
      getCur(cur){
        return Math.round(this.bill * this.rates[cur]);
      }
    }
}
</script>
